var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"position-relative ed-icon bsx-d-flex"},[_c('i',{ref:"icon",class:_vm.classIcon,style:({ color: _vm.color, fontSize: _vm.iconSize }),attrs:{"name":_vm.icon,"title":_vm._title}})])}
var staticRenderFns = []

export { render, staticRenderFns }